import '../App.css'

function Footer() {

  return (
    <footer>
      <p>De inhoud van deze website is puur satirisch en niet bedoeld om serieus genomen te worden. De weergegeven informatie moet niet worden beschouwd als feitelijke, objectieve, of politieke richtlijnen. Wij moedigen onze bezoekers aan om de humoristische aard van deze site te omarmen en geen politieke beslissingen te nemen op basis van de inhoud ervan.</p>
    </footer>
  )
}

export default Footer
